import React, { useEffect, useState } from "react";
import { Toolbar, AppBar } from '@material-ui/core'
import { obtenerValoresFiltros } from "../../../global/js/funciones";
import TareasTerminadas from '../../general/TareasTerminadas'
import emma_w from './../../../global/imagenes/emma_w.png'


export default function Politica() {
    const [cargando, setCargando] = useState(true);
    const [link, setLink] = useState('');


    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setCargando(true)

        let resultado = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Pol_Dat_Cuc' },
        { 'llave': 'estado', 'valor': '1' }]);

        setLink(resultado[0] ? resultado[0].archivo : '')
        setCargando(false)

    }




    return (
        <div style={{ padding: 20 }}>
            <AppBar position="fixed" elevation={0}>
                <Toolbar>
                    <div style={{ padding: "5px 0px 5px 3px", color: 'white', margin: 'auto', }}>
                        <p><span style={{ marginLeft: "10px", fontSize: '20px' }}>POLITICA DE DATOS</span> </p>
                    </div>
                </Toolbar>
            </AppBar>

            {
                !cargando ? <div style={{ marginTop: '100px' }}>
                    <iframe
                        src={link}
                        title="Política de privacidad"
                        style={{ width: "100%", height: "80vh", border: "1px solid #ddd" }}
                    />
                </div> :
                    <TareasTerminadas
                        mensaje="Cargando.."
                        marginTop="7%"
                        imagen={emma_w}
                        widthImg="7%"
                        cargando={true}
                    />

            }

        </div>
    );
}